import { CheckCircle2, XCircle, Trophy } from "lucide-react";
import { Stars } from "../Stars";
import { REVIEWS } from "../../data/comparison";
import { AFF_DISCLOSURE } from "../../lib/constants";
import { trackCta } from "../../lib/tracking";

export const Reviews = () => (
  <section className="bg-[#F8FAFC] py-20" data-testid="mini-reviews-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-3">Editorial verdicts</p>
      <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A] mb-12">
        Platform-by-Platform Reviews
      </h2>
      <div className="space-y-8">
        {REVIEWS.map((r) => (
          <article
            key={r.name}
            data-testid={`review-card-${r.rank}`}
            className={`bg-white rounded-lg p-8 sm:p-10 ${r.winner ? "border-2 border-[#5A31F4] shadow-lg" : "border border-slate-200"}`}
          >
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-64 shrink-0">
                <div className="flex items-center gap-3">
                  <span className={`w-9 h-9 rounded-full flex items-center justify-center font-heading font-bold text-sm ${r.winner ? "bg-[#5A31F4] text-white" : "bg-slate-100 text-slate-600"}`}>
                    {r.rank}
                  </span>
                  <h3 className="font-heading text-xl sm:text-2xl font-bold text-[#0F172A]">{r.name}</h3>
                </div>
                {r.winner && (
                  <span className="inline-flex items-center gap-1.5 mt-3 text-xs font-bold uppercase tracking-[0.15em] text-[#5A31F4]">
                    <Trophy className="w-4 h-4" /> Editor's Choice
                  </span>
                )}
                <div className="mt-4 flex items-center gap-2">
                  <Stars rating={r.rating} />
                  <span className="font-bold text-[#0F172A]">{r.rating}/5</span>
                </div>
                <dl className="mt-4 text-sm space-y-1.5 text-slate-600">
                  <div><dt className="inline font-semibold text-slate-800">Price from: </dt><dd className="inline">{r.price}</dd></div>
                  <div><dt className="inline font-semibold text-slate-800">Best for: </dt><dd className="inline">{r.bestFor}</dd></div>
                </dl>
                <a
                  href={r.link}
                  target="_blank"
                  rel="nofollow sponsored noopener"
                  onClick={() => trackCta(`review-${r.name.toLowerCase().replace(/\./g, "")}`, r.link)}
                  data-testid={`cta-review-${r.rank}`}
                  className={`mt-6 inline-block rounded-md px-5 py-3 text-sm font-bold transition-all duration-200 hover:-translate-y-0.5 ${
                    r.winner ? "bg-[#5A31F4] text-white hover:bg-[#4B29CD] shadow-md" : "border border-slate-300 text-slate-700 hover:border-slate-500"
                  }`}
                >
                  {r.ctaText}
                </a>
                {r.winner && (
                  <p className="mt-3 text-[11px] text-slate-500 leading-snug" data-testid="review-affiliate-disclosure">{AFF_DISCLOSURE}</p>
                )}
              </div>
              <div className="flex-1">
                <p className="text-base text-slate-700 leading-relaxed">{r.body}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
                  <div>
                    <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-[#16A34A] mb-3">Pros</h4>
                    <ul className="space-y-2">
                      {r.pros.map((p) => (
                        <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                          <CheckCircle2 className="w-4 h-4 text-[#16A34A] shrink-0 mt-0.5" />{p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-400 mb-3">Cons</h4>
                    <ul className="space-y-2">
                      {r.cons.map((c) => (
                        <li key={c} className="flex items-start gap-2 text-sm text-slate-600">
                          <XCircle className="w-4 h-4 text-slate-300 shrink-0 mt-0.5" />{c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {r.bottomLine && (
                  <p className="mt-6 text-sm font-semibold text-[#0F172A] bg-[#5A31F4]/5 border-l-4 border-[#5A31F4] px-4 py-3 rounded-r">
                    Bottom line: {r.bottomLine}
                  </p>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
